import { getWhatsappEndpoint } from "../../../../marketplace-commons/helpers/getWhatsappEndpoint";
import { FooterItemType, FooterItemUrlType } from "../../../types/footer";
export var contructItemUrl = function (url, urlType) {
    var sanitizedUrl = (url === null || url === void 0 ? void 0 : url.trim()) || "";
    switch (urlType) {
        case FooterItemUrlType.Email:
            return "mailto:" + sanitizedUrl;
        case FooterItemUrlType.Phone:
            return "tel:" + sanitizedUrl;
        case FooterItemUrlType.Whatsapp:
            return "" + getWhatsappEndpoint() + sanitizedUrl;
    }
    return sanitizedUrl;
};
export var isValidItem = function (_a) {
    var url = _a.url, type = _a.type;
    return !((type === FooterItemType.Link || type === FooterItemType.Button) && !url);
};
//# sourceMappingURL=helpers.js.map